import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './screens/LoginPage';
import { DashboardPage } from './screens/DashboardPage';
import { CandidaturesPage } from './screens/CandidaturesPage';
import { UsersPage } from './screens/UsersPage';
import { PostsPage } from './screens/PostsPage';
import { SchoolsPage } from './screens/SchoolsPage';
import { ActivitiesPage } from './screens/ActivitiesPage';
import { PaymentsPage } from './screens/PaymentsPage';
import { ReportsPage } from './screens/ReportsPage';
import { ImportsPage } from './screens/ImportsPage';
import { PlaceholderPage } from './screens/PlaceholderPage';
import { SettingsPage } from './screens/SettingsPage';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { AuthProvider } from './auth/AuthContext';
import { MainLayout } from './layout/MainLayout';

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={['admin', 'drh', 'cap', 'ae']}>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin', 'drh', 'cap', 'ae']}>
              <MainLayout>
                <DashboardPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/candidatures"
          element={
            <ProtectedRoute allowedRoles={['admin', 'drh', 'cap', 'ae']}>
              <MainLayout>
                <CandidaturesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/posts"
          element={
            <ProtectedRoute allowedRoles={['admin', 'drh', 'cap', 'ae']}>
              <MainLayout>
                <PostsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/schools"
          element={
            <ProtectedRoute allowedRoles={['admin', 'drh', 'cap', 'ae']}>
              <MainLayout>
                <SchoolsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/activities"
          element={
            <ProtectedRoute allowedRoles={['admin', 'cap', 'ae', 'drh']}>
              <MainLayout>
                <ActivitiesPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/payments"
          element={
            <ProtectedRoute allowedRoles={['admin', 'cap', 'ae', 'drh']}>
              <MainLayout>
                <PaymentsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <MainLayout>
                <UsersPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/imports"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <MainLayout>
                <ImportsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/exports"
          element={
            <ProtectedRoute>
              <MainLayout>
                <PlaceholderPage title="Exports" />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
              <MainLayout>
                <ReportsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <MainLayout>
                <SettingsPage />
              </MainLayout>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;

